module.exports = {"511524100":"长宁镇","511524101":"梅硐镇","511524102":"双河镇","511524103":"硐底镇","511524104":"花滩镇","511524105":"竹海镇","511524106":"老翁镇","511524107":"古河镇","511524108":"下长镇","511524110":"龙头镇","511524111":"开佛镇","511524112":"铜鼓镇","511524113":"井江镇","511524200":"铜锣乡","511524201":"桃坪乡","511524205":"三元乡","511524207":"富兴乡","511524208":"梅白乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511524.json
// module id = 2360
// module chunks = 0